<template>
  <div class="flex flex-col h-screen overflow-auto bg-gradient-to-r from-darkPurple to-darkBlue">
    <router-view />
  </div>
</template>
<script setup lang="ts">
</script>
